__turbopack_context__.v({
  "count": "SimulatorCompetitionList-module__Cvb_Ja__count",
  "filters": "SimulatorCompetitionList-module__Cvb_Ja__filters",
});
